import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import { getReportActionsSuccess, getReportActionsFailure } from '../actions';
import { BACKEND_URL, getAuthConfig } from 'src/pages/DashboardPage/vpo/api/api';

export function* getReportActionsSaga({ payload }: any) {
  try {
    if (payload) {
      const { columnReportAction, department, factoryReport, groupReportPeriod, year } = payload;

      const params: any = {
        year: year.selected[0] || year.selectedIds[0],
      };

      if (columnReportAction?.selectedIds?.length > 0) {
        params.columnId = columnReportAction.selectedIds;
      }

      if (groupReportPeriod?.selectedIds?.length > 0) {
        params.groupIds = groupReportPeriod.selectedIds;
      }

      if (factoryReport?.selectedIds?.length > 0) {
        params.factoryIds = factoryReport.selectedIds;
      }

      if (department?.selectedIds?.length > 0) {
        params.departmentIds = department.selectedIds;
      }

      const response = yield call(axios.get, `${BACKEND_URL}/api/vpo-report-actions`, {
        ...getAuthConfig(),
        params,
      });

      if (response.data.success) {
        yield put(
          getReportActionsSuccess({
            data: response.data.data,
            filters: {
              columnReportAction,
              department,
              factoryReport,
              groupReportPeriod,
              year,
            },
          })
        );
      } else {
        yield put(getReportActionsFailure(response.data.error || 'Ошибка при получении данных'));
      }
    }
  } catch (error: any) {
    console.error('Ошибка в getReportActionsSaga:', error);
    yield put(getReportActionsFailure(error.message || 'Ошибка при получении данных'));
  }
}
